// extracted by mini-css-extract-plugin
export default {"btnBlue":"ButtonModal_btnBlue__buqtW"};